import React, { FC } from 'react';
import { Switch, Route, Redirect } from 'react-router-dom'
import Dashboard from '../Dashboard';
import PersonalDetails from '../PersonalDetails';
import Profile from '../Profile';
import Email from '../Email';
import PhoneNumber from '../PhoneNumber';
import Bookings from '../Bookings';
import Billing from '../Billing';
import Security from '../Security';
import Help from '../Help';
import { AccountContentContainer } from './style';

const AccountContent: FC = () => {

  return (
    <AccountContentContainer>
      <Switch>

        <Route path="/account/dashboard" render={() => <Dashboard />} />
        <Route path="/account/personal-details" render={() => <PersonalDetails />} />
        <Route path="/account/profile" render={() => <Profile />} />
        <Route path="/account/email" render={() => <Email />} />
        <Route path="/account/phone-number" render={() => <PhoneNumber />} />
        <Route path="/account/bookings" render={() => <Bookings />} />
        <Route path="/account/billing" render={() => <Billing />} />
        <Route path="/account/security" render={() => <Security />} />
        <Route path="/account/help" render={() => <Help />} />

        {/* Redirects from old CamelCase paths */}
        <Redirect from="/account/personalDetails" to="/account/personal-details" />
        <Redirect from="/account/phoneNumber" to="/account/phone-number" />

        {/* Default fallback */}
        <Redirect to="/account/dashboard" />

        {/* <Route path={'/account/dashboard'} render={() => <Dashboard />} />
        <Route path={'/account/personalDetails'} render={() => <PersonalDetails />} />
        <Route path={'/account/profile'} render={() => <Profile />} />
        <Route path={'/account/email'} render={() => <Email />} />
        <Route path={'/account/phoneNumber'} render={() => <PhoneNumber />} />
        <Route path={'/account/bookings'} render={() => <Bookings />} />
        <Route path={'/account/billing'} render={() => <Billing />} />
        <Route path={'/account/security'} render={() => <Security />} />
        <Route path={'/account/help'} render={() => <Help />} />
        <Redirect to={'/account/dashboard'} /> */}
      </Switch>
    </AccountContentContainer>
  );
};

export default AccountContent;
